import React from 'react';
import {TerritoryRulesContainer} from '../../Containers/TerritoryContainer';


const TerritoryRules = (props) => {
	return (
		<TerritoryRulesContainer />
	);
}

export default TerritoryRules;